import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "filter", "item", "row", "empty", "count"]

  connect() {
    this.apply()
  }

  apply() {
    const query = this.searchTerm
    const filters = this.activeFilters

    this.itemTargets.forEach((item) => {
      item.hidden = !this.matches(item, query, filters)
    })

    const visibleRows = this.rowTargets.filter((row) => !row.hidden).length
    if (this.hasCountTarget) this.countTarget.textContent = visibleRows
    if (this.hasEmptyTarget) this.emptyTarget.hidden = visibleRows > 0
  }

  clear() {
    if (this.hasSearchTarget) this.searchTarget.value = ""
    this.filterTargets.forEach((filter) => {
      filter.value = "all"
    })
    this.apply()
    if (this.hasSearchTarget) this.searchTarget.focus()
  }

  matches(item, query, filters) {
    const searchText = (item.dataset.search || "").toLowerCase()
    const filterText = item.dataset.filters || ""
    const searchMatch = query.length === 0 || searchText.includes(query)
    const filterMatch = filters.every(([key, value]) => filterText.split(/\s+/).includes(`${key}:${value}`))

    return searchMatch && filterMatch
  }

  get searchTerm() {
    if (!this.hasSearchTarget) return ""

    return this.searchTarget.value.trim().toLowerCase()
  }

  get activeFilters() {
    return this.filterTargets
      .map((filter) => [filter.dataset.filterKey, filter.value])
      .filter(([key, value]) => key && value && value !== "all")
  }
}
